var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoreEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 10.8327C3.79357 10.8327 4.16667 10.4596 4.16667 9.99935C4.16667 9.53911 3.79357 9.16602 3.33333 9.16602C2.8731 9.16602 2.5 9.53911 2.5 9.99935C2.5 10.4596 2.8731 10.8327 3.33333 10.8327Z",
    stroke: "#C2D1DD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 10.8327C10.4615 10.8327 10.8346 10.4596 10.8346 9.99935C10.8346 9.53911 10.4615 9.16602 10.0013 9.16602C9.54106 9.16602 9.16797 9.53911 9.16797 9.99935C9.16797 10.4596 9.54106 10.8327 10.0013 10.8327Z",
    stroke: "#C2D1DD",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6654 10.8327C17.1256 10.8327 17.4987 10.4596 17.4987 9.99935C17.4987 9.53911 17.1256 9.16602 16.6654 9.16602C16.2051 9.16602 15.832 9.53911 15.832 9.99935C15.832 10.4596 16.2051 10.8327 16.6654 10.8327Z",
    stroke: "#C2D1DD",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreEllipsis);
export default __webpack_public_path__ + "static/media/more_ellipsis.8551266b4eb63dceccbf6eaa74362b3d.svg";
export { ForwardRef as ReactComponent };